import { Grid } from "@material-ui/core";
import { Block, Print } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import PrintCommon from "app/common/Component/Print/PrintCommon";
import { LIST_DATE_UNIT } from "app/common/LocalConst";
import { formatMoney, getDateTime, getImgLogo, getPrintPatientCode, getSystemConfig, hideMiddleDigits } from "app/common/LocalFunction";
import { observer } from "mobx-react";
import { memo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useReactToPrint } from "react-to-print";

function WarrantyServiceInfoPopup({ open, handleClose, dataService }) {
  // console.log("🚀 ~ WarrantyServiceInfoPopup ~ dataService:", dataService)
  const { t } = useTranslation();

  const componentRef = useRef();
  const handlePrintWarranty = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Phiếu bảo hành",
  });

  return (
    <PopupForm
      size="lg"
      title="Thông tin dịch vụ bảo hành"
      open={open}
      handleClose={handleClose}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton
              className="btn-primary"
              disabled={isSubmitting}
              onClick={handlePrintWarranty}
            >
              {<Print className="mr-2 " />}
              In phiếu bảo hành
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <PrintCommon ref={componentRef} marginPage="8mm" hidden={false}>
            <div className="warranty-wrapper">
              <div className="warranty-container">
                <header className="warranty-header">
                  <div className="header-left">
                    <div className="title-web-mobile title-web flex align-center gap-1">
                      {getImgLogo({ height: "40px", width: "40px" })}
                      <strong>
                        {getSystemConfig("ORG_NAME") || <>{t("nameApp")}</>}
                      </strong>
                    </div>
                    <div className="organization">Cơ sở: {dataService?.department?.name || ""}</div>
                  </div>

                  <div className="header-right">
                    <h2>PHIẾU BẢO HÀNH DỊCH VỤ</h2>
                    <p>
                      <strong>Ngày đăng ký:</strong> {getDateTime(dataService?.orderDate)}
                    </p>
                  </div>
                </header>

                <section className="info-grid">
                  <div className="info-box">
                    <h3>Thông tin khách hàng</h3>
                    <p>
                      <strong>Tên:</strong> {dataService?.patient?.displayName}{" "}
                      {getPrintPatientCode(dataService?.patient)
                        ? `(${getPrintPatientCode(dataService?.patient)})`
                        : null}
                    </p>
                    <p>
                      <strong>SĐT:</strong> {hideMiddleDigits(dataService?.patient?.phoneNumber) || ""}
                    </p>
                    <p>
                      <strong>Địa chỉ:</strong>{" "}
                      {dataService.patient.address || "---"}
                    </p>
                  </div>

                  <div className="info-box">
                    <h3>Thông tin bảo hành</h3>

                    <p>
                      <strong>Tên dịch vụ:</strong>{" "}
                      {dataService?.name || "---"}
                    </p>

                    <p>
                      <strong>Ngày bắt đầu điều trị:</strong>{" "}
                      {dataService?.orderDate
                        ? new Date(dataService.orderDate).toLocaleDateString("vi-VN")
                        : "---"}
                    </p>

                    <p>
                      <strong>Thời hạn bảo hành:</strong>{" "}
                      {dataService?.warrantyDuration}{" "}
                      {
                        LIST_DATE_UNIT.find(u => u.value === dataService?.warrantyUnit)
                          ?.name || ""
                      }
                    </p>

                    <p>
                      <strong>Ngày hết hạn bảo hành:</strong>{" "}
                      {dataService?.warrantyExpiryDate
                        ? new Date(dataService.warrantyExpiryDate).toLocaleDateString("vi-VN")
                        : "---"}
                    </p>

                    <p>
                      <strong>Số lần được bảo hành:</strong>{" "}
                      {dataService?.warrantyTotalTimes ?? "---"}
                    </p>

                    <p>
                      <strong>Số lần đã bảo hành:</strong>{" "}
                      {dataService?.warrantyUsedTimes ?? "---"}
                    </p>

                    <p>
                      <strong>Số lần còn lại:</strong>{" "}
                      {dataService && dataService.warrantyTotalTimes - dataService.warrantyUsedTimes}
                    </p>
                  </div>
                </section>

                <section className="service-section">
                  <h3>Danh sách dịch vụ bảo hành</h3>
                  <div style={{ overflowX: "auto" }}>
                  <table className="service-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Tên dịch vụ</th>
                        <th>SL</th>
                        <th>Đơn giá</th>
                        <th>Giảm giá</th>
                        <th>Thành tiền</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 1</td>
                        <td>{dataService?.service?.name || "---"}</td>
                        <td>{dataService?.quantity ?? 0}</td>
                        <td>{formatMoney(dataService?.price || 0)}</td>
                        <td>{formatMoney(dataService?.discount || 0)}</td>
                        <td>{formatMoney(dataService?.totalBillPatientPaid || 0)}</td>
                      </tr>
                    </tbody>
                  </table>
                  </div>

                  <div className="total">Tổng cộng: {formatMoney(dataService?.totalBillPatientPaid || 0)}</div>
                </section>

                <section className="warranty-terms">
                  <h3>Điều kiện bảo hành</h3>
                  <ul>
                    <li>Chỉ áp dụng cho các dịch vụ được ghi trong phiếu.</li>
                    <li>
                      Không bảo hành nếu khách hàng tự ý can thiệp hoặc sử dụng
                      sai hướng dẫn.
                    </li>
                    <li>
                      Phiếu có giá trị đến hết ngày {getDateTime(dataService?.warrantyExpiryDate)}.
                    </li>
                  </ul>
                </section>

                <section className="sign-section">
                  <div>
                    <h4>Người lập phiếu</h4>
                    <p>{dataService?.createdBy}</p>
                    <span>(Ký và ghi rõ họ tên)</span>
                  </div>

                  <div>
                    <h4>Khách hàng</h4>
                    <p>{dataService?.patient?.displayName}</p>
                    <span>(Ký xác nhận và ghi rõ họ tên)</span>
                  </div>
                </section>
              </div>
            </div>
          </PrintCommon>
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(WarrantyServiceInfoPopup));
